export default __webpack_public_path__ + "static/media/Viet_Banner_2.fa2dc26e.webp";